import React from "react";
import { Container, Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const LAST_UPDATE_DATE = "2025-07-27";

const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper sx={{ p: { xs: 2, md: 5 }, borderRadius: 4, boxShadow: 6 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          {t("terms.title")}
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          {t("terms.last_updated", { date: LAST_UPDATE_DATE })}
        </Typography>
        <Box mt={3} mb={2}>
          <Typography variant="body1">{t("terms.accept")}</Typography>
        </Box>
        {Array.from({ length: 7 }).map((_, i) => (
          <Box key={i} mb={2}>
            <Typography variant="h6" gutterBottom>
              {t(`terms.${i + 1}_title`)}
            </Typography>
            <Typography variant="body1">{t(`terms.${i + 1}_text`)}</Typography>
          </Box>
        ))}
      </Paper>
    </Container>
  );
};

export default TermsOfService;
